import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ListingPageId } from '@portal/shared/components/listing-page/store/listing-page-store.types';
import { Search } from '@ui/aos-lib';
import {
  Applicable,
  EditReportGroupsFormData,
  ReportGroupsCreationAPIBody
} from 'src/app/pages/administration/report-groups/report-groups.types';
import { Filter } from 'src/app/pages/equipment/devices/components/devices.models';

export const MapReportGroupActions = createActionGroup({
  source: 'MapReportGroup',
  events: {
    'Update Selected Area': props<{ area: [number, number][] }>(),
    'Close Modal': emptyProps(),
    'Update Report Group Form Data': props<{ formData: EditReportGroupsFormData }>(),
    'Create Report Group': props<{ payload: ReportGroupsCreationAPIBody; source: string; pageId?: ListingPageId }>(),
    'Create Report Group Success': props<{ source: string; pageId?: ListingPageId }>(),
    'Toggle Report Group Creation': props<{ paused: boolean }>(),
    'Cancel Report Group Creation': emptyProps(),
    'Fetch Devices For Selected Area': props<{ filters: Filter[]; search?: Search; source: string }>(),
    'Fetch Devices For Selected Area Success': props<{ deviceIds: string[] }>(),
    'Update Initial Applicable': props<{ applicable: Applicable }>()
  }
});
